import React from "react";
import GreyBackgroundPage from "../../components/GreyBackgroundPage";
import TripSummary from "../../components/TripSummary";
import withRedirectToHomePage from "../../components/withRedirectToHomePage";

import CustomerInfoForm from "./CustomerInfoForm";
import { getSelectedTrip } from "../../data/trips/selectors";
import ImportantInformation from "../../components/ImportantInformation";
import ChargesSummary from "./ChargesSummary";

import { connect } from "react-redux";
import { reduxForm } from "redux-form";

import styled from "styled-components";
import TrialPeriodOverModal from "../../components/TrialPeriodOverModal";
import Card from "../../components/Card";
import MediaQuery from "../../components/MediaQuery";

// Styled components
const TripSummaryWrapper = styled.div`
  margin-bottom: 15px;
`;

const ShowInDesktopOnly = styled.div`
  ${MediaQuery.tablet`
    display: none;
  `};
`;
const ShowInMobileOnly = styled.div`
  ${MediaQuery.desktop`
    display: none;
  `};
`;
const ImportantInformationWrap = styled.div`
  padding: 15px;
  margin-left: 15px;
  padding-top: 0;
`;

const ChargesSummaryCard = styled(Card)`
  ${MediaQuery.desktop`
    margin-left: 15px;
  `};
  ${MediaQuery.tablet`
    margin-left: 0;
    margin-top: 15px;
    margin-bottom: 15px;
  `};
`;

const DesktopWrapper = styled.div`
  display: flex;
`;
const RightLayout = styled.div`
  flex: 1;
`;
const LeftLayout = styled.div`
  flex: 2;
`;

class ReviewOrder extends React.Component {
  render() {
    const {
      dateDisplayDepartingTrip,
      dateDisplayReturningTrip,
      returningTripSegments,
      departingTripSegments,
      isRoundTrip,
      selectedTrip
    } = this.props;

    // Create reusable section, so we don't forget to alter both versions,
    // mobile vs desktop, case (in the event its props are changed)
    const renderChargesSummary = (
      <ChargesSummaryCard>
        <ChargesSummary {...selectedTrip.tripFinancials} />
      </ChargesSummaryCard>
    );

    const renderImportantInfo = (
      <ImportantInformationWrap>
        <ImportantInformation
          fareRules={selectedTrip.tripFinancials.fareRules}
        />
      </ImportantInformationWrap>
    );

    const renderTripSummary = (
      <TripSummaryWrapper>
        <TripSummary
          {...{
            baggageFeesUrlDeparting:
              selectedTrip.tripInfo.departing.baggageFeeUrl,
            baggageFeesUrlReturning:
              isRoundTrip && selectedTrip.tripInfo.returning.baggageFeeUrl,
            dateDisplayDepartingTrip,
            dateDisplayReturningTrip,
            departingTripSegments,
            returningTripSegments
          }}
        />
      </TripSummaryWrapper>
    );

    const renderCustomerInfo = (
      <Card>
        <CustomerInfoForm />
      </Card>
    );

    return (
      <GreyBackgroundPage
        stepperText={`Step ${
          isRoundTrip ? "3 of 3:" : "2 of 2:"
        } Make Down Payment`}
      >
        {/* Popup for trial period message */}
        <TrialPeriodOverModal />

        {/* Desktop content */}
        <ShowInDesktopOnly>
          <DesktopWrapper>
            <LeftLayout>
              {renderTripSummary}
              {renderCustomerInfo}
            </LeftLayout>
            <RightLayout>
              {renderChargesSummary}
              {renderImportantInfo}
            </RightLayout>
          </DesktopWrapper>
        </ShowInDesktopOnly>

        {/* Mobile content */}
        <ShowInMobileOnly>
          {renderTripSummary}
          {renderCustomerInfo}
          {renderChargesSummary}
          {renderImportantInfo}
        </ShowInMobileOnly>
      </GreyBackgroundPage>
    );
  }
}

function mapStateToProps(state) {
  const selectedTrip = getSelectedTrip(state);
  const redirectToHomePage = !selectedTrip;

  // Redirect to home page if page is entered in incorrect state
  if (redirectToHomePage) return { redirectToHomePage }; // HOC would automatically redirect to Home page after receiving this prop

  const isRoundTrip = selectedTrip && !!selectedTrip.tripInfo.returning; // getLandingPageFormValues(state).isRoundTrip
  return {
    numberOfETickets: selectedTrip.tripInfo.numberOfETickets,
    departingTripSegments: selectedTrip.tripInfo.departing.tripSegments,
    returningTripSegments:
      isRoundTrip && selectedTrip.tripInfo.returning.tripSegments,
    dateDisplayDepartingTrip:
      selectedTrip.tripInfo.departing.departureDateDisplay,
    dateDisplayReturningTrip:
      isRoundTrip && selectedTrip.tripInfo.returning.departureDateDisplay,
    isRoundTrip,
    selectedTrip
  };
}

let reduxFormDecoratedComp = reduxForm({
  form: "reviewOrder"
})(withRedirectToHomePage(ReviewOrder));

export default connect(mapStateToProps)(reduxFormDecoratedComp);



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/index.js